






































































































import { IAgentService } from "@/services/IAgentService";
import { IStoreService } from "@/services/IStoreService";
import { container } from "@/services/registerServiceProvider";
import { IAuthService, NullPointerException, StateMachine, UnAuthorizedException } from "frontend-core";
import { Component, Inject, Vue } from "vue-property-decorator";
import { AuthMethod, AuthStep, Credentials } from "../modules/Login/Models/Credentials";
import { CredentialsDTO } from "../modules/Login/Dto/CredentialsDTO";
import { ILoginService } from "../modules/Login/Services/ILoginService";
import { LoginService } from "@/modules/Login/Services/LoginService";

@Component
export default class LoginView extends Vue {
  public show: boolean = false;
  public smsCode: string = '';
  public errorMsg: string = "В доступе отказано";
  public readonly credentials: Credentials = new Credentials();
  public readonly state: StateMachine = new StateMachine("idle", {
    idle: ["loading"],
    loading: ["idle", "error", "success"],
    error: ["loading"],
    success: ["loading"],
  });
  public AuthMethod = AuthMethod;
  public AuthStep = AuthStep;

  @Inject()
  private readonly storeService!: IStoreService;

  private readonly loginService: ILoginService = new LoginService();
  private readonly agentService: IAgentService =
      container.resolve("IAgentService");
  private readonly authService: IAuthService =
      container.resolve("IAuthService");

  created(): void {
    if (this.storeService.appState.state === "loading") {
      this.storeService.appState.transition("idle");
    }
  }

  public async loginFirstStep(authMethod: AuthMethod): Promise<void> {
    this.state.transition("loading");
    this.credentials.method = authMethod;

    const dto: CredentialsDTO = new CredentialsDTO(this.credentials);

    await this.loginService
      .login(dto)
      .then(async (response) => {
        if (!(response.status === 200)) {
          throw new UnAuthorizedException(response.status + response.statusText);
        } else if (!response.data.token && response.data.success) {
          this.state.transition("idle");
          this.credentials.step = AuthStep.Second;

          if (this.credentials.method === AuthMethod.Call) {
            setTimeout(this.loginWithCall, 5000);
          }
        }
      })
      .catch((e) => {
        if (e.response?.data?.message) {
          this.errorMsg = e.response?.data?.message;
        }
        this.authService.logout();
        this.state.transition("error");
      });
  }

  async loginWithCode() {
    this.state.transition("loading");
    this.credentials.f2aCode = this.smsCode;

    const dto: CredentialsDTO = new CredentialsDTO(this.credentials);

    await this.loginService
      .login(dto)
      .then(async (response) => {
        if (!(response.status === 200)) {
          throw new UnAuthorizedException(response.status + response.statusText);
        } else if (response.data.token) {
          this.storeService.currentAgent = await this.agentService.getCurrent();
          if (!this.storeService.currentAgent) {
            throw new NullPointerException("current agent after login");
          }
          this.state.transition("success");
          await this.$router
          .push({
            path:
              (this.$route.params.nextUrl || this.storeService.currentPath) ??
              "/",
          })
          .then(() => {
            this.storeService.isManualLogout = false;
            this.storeService.currentPath = null;
          });
        }
    })
      .catch((e) => {
        if (e.response?.data?.message) {
          this.errorMsg = e.response?.data?.message;
        }
        this.authService.logout();
        this.state.transition("error");
      });
  }

  async loginWithCall() {
    this.state.transition("loading");

    const dto: CredentialsDTO = new CredentialsDTO(this.credentials);

    await this.loginService
    .login(dto)
    .then(async (response) => {
      if (!(response.status === 200)) {
        throw new UnAuthorizedException(response.status + response.statusText);
      } else if (response.data.token) {
        this.storeService.currentAgent = await this.agentService.getCurrent();
        if (!this.storeService.currentAgent) {
          throw new NullPointerException("current agent after login");
        }
        this.state.transition("success");
        await this.$router
        .push({
          path:
            (this.$route.params.nextUrl || this.storeService.currentPath) ??
            "/",
        })
        .then(() => {
          this.storeService.isManualLogout = false;
          this.storeService.currentPath = null;
        });
      }
    })
    .catch((e) => {
      if (e.response?.data?.message) {
        if (e.response.data.message === 'Не было звонка на проверочный номер') {
          setTimeout(this.loginWithCall, 5000);

          return;
        } else {
          this.errorMsg = e.response.data.message;
        }
      }
      this.authService.logout();
      this.state.transition("error");
    });
  }
}
